import { useState } from "react";
import { BrandMark } from "./Logo";
import { useLanguage } from "@/context/AppContext";

export default function Header() {
  const { t, toggleLang } = useLanguage();
  const [open, setOpen] = useState(false);

  const links = [
    ["#story", t.nav.story],
    ["#family", t.nav.family],
    ["#ventures", t.nav.ventures],
    ["#values", t.nav.values],
    ["#legacy", t.nav.legacy],
    ["#contact", t.nav.contact],
  ];

  return (
    <header className="site-header" data-testid="site-header">
      <a className="brand" href="#home" data-testid="nav-logo-link" aria-label="My10Sons home">
        <span className="brand-mark" aria-hidden="true">
          <BrandMark />
        </span>
        <span>
          <strong>
            My<span>10</span>Sons
          </strong>
          <small>{t.brandTag}</small>
        </span>
      </a>
      <button className="menu-toggle" data-testid="nav-mobile-menu-button" aria-label="Open menu" onClick={() => setOpen(!open)}>
        ☰
      </button>
      <nav className={`nav ${open ? "open" : ""}`} data-testid="site-nav">
        {links.map(([href, label]) => (
          <a key={href} href={href} data-testid={`nav-link-${href.slice(1)}`} onClick={() => setOpen(false)}>
            {label}
          </a>
        ))}
      </nav>
      <button className="lang" data-testid="nav-language-toggle" aria-label="Switch language" onClick={toggleLang}>
        {t.langBtn}
      </button>
    </header>
  );
}
